import { render, staticRenderFns } from "./ColorInfo.vue?vue&type=template&id=67d18193&scoped=true&"
import script from "./ColorInfo.vue?vue&type=script&lang=js&"
export * from "./ColorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColorInfo.vue?vue&type=style&index=0&id=67d18193&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d18193",
  null
  
)

export default component.exports